<section class="table-row">
  <div class="product-image-container row-item">
    <img *ngIf="product?.images.length" [src]="product?.images[0]?.src"/>
  </div>
  <div class="product-title row-item">
    <a class="db-link" [routerLink]="'edit-product/'+product?.id">{{product?.name}}</a>
  </div>
  <div class="product-inventory row-item">
    {{product.stock_status === ProductStockStatus.OUT_OF_STOCK ? ('text_outOfStock' | dbText) : product?.stock_quantity}}
  </div>
  <div class="product-category row-item">
    <span *ngIf="product?.categories.length">
      {{product?.categories[0].name}}
    </span>
  </div>
  <div class="product-price row-item">
    {{price}}
  </div>
  <div class="product-status-container row-item">
    <ds-dropdown [formControl]="status"
                 [dsDropdownOptions]="statusOptions" [dsDropdownWidth]="'120px'"
                 [value]="product?.status"
                 (onOptionChoose)="statusChange($event)"></ds-dropdown>
  </div>
  <div class="product-actions table-actions row-item">
   <a [href]="productUrl+product.slug"
      *ngIf="status?.value === 'publish' && product.slug"
      target="_blank">
     <i class="db-icon db-icon-eye mr10"></i>
   </a>
    <a [dsTooltip]="dropdownList"
       class="dropdown"
       dsTooltipMode="click"
       dsTooltipPosition="bottom"
       dsTooltipAlign="right"
       dsTooltipSize="xs">
      <i class="db-icon db-icon-ds-more-l"></i>
    </a>
    <ng-template #dropdownList>
      <div class="db-dropdown-list">
        <div class="db-dropdown-list__content">
          <div>
            <ul>
              <li *ngFor="let item of dropdownOptions"><a class="db-dropdown-list__item {{item.className}}"
                                                          (click)="item.action()">
                <i class="db-icon db-icon-{{item.icon}}" *ngIf="item.icon"></i><span>{{item.label}}</span></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</section>
